import { render, staticRenderFns } from "./_img.vue?vue&type=template&id=ed134d22"
import script from "./_img.vue?vue&type=script&lang=js"
export * from "./_img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports